module.exports = __webpack_public_path__ + "static/media/tags-cloud.7725315b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/tags/tags-cloud.png
// module id = 447
// module chunks = 0